// @flow

import React from 'react';
import ActionConfirmation from '../../containers/ActionConfirmation/ActionConfirmation';
import LoadingIndicator from '../LoadingIndicator/LoadingIndicator';
import ModalDialog from '../ModalDialog/ModalDialog';
import OrderCommentForm from '../OrderCommentForm/OrderCommentForm';
import ServerError from '../ServerError/ServerError';
import './OrderCommentDialog.css';

export type Props = {
  error: ?any,
  formValues: any,
  isLoading: boolean,
  onClose: () => any,
  onRemove: () => any,
  onSave: () => any,
  orderComment: any,
  roomTypes: any[],
  validate: Function,
  workerTypes: any[],
};

const OrderCommentDialog = ({
  error,
  formValues,
  isLoading,
  onClose,
  onRemove,
  onSave,
  orderComment,
  roomTypes,
  validate,
  workerTypes,
}: Props) => (
  <div>
    <ModalDialog
      onClose={onClose}
      className="OrderCommentDialog"
      show={true}>
      <LoadingIndicator isLoading={isLoading} />
      <ServerError error={error} />
      <OrderCommentForm
        formValues={formValues}
        initialValues={orderComment}
        roomTypes={roomTypes}
        validate={validate}
        workerTypes={workerTypes} />
      <button
        type="button"
        className="expanded button"
        onClick={onSave}>
        Spara
      </button>
      {!!orderComment && !!orderComment.id && (
        <ActionConfirmation
          action={() => onRemove()}
          buttonText="Ta bort"
          className="expanded warning"
          id="removeOrderComment"
          message="Vill du verkligen ta bort den här kommentaren?" />
      )}
      <button
        type="button"
        className="expanded button"
        onClick={onClose}>
        Avbryt
      </button>
    </ModalDialog>
  </div>
);

export default OrderCommentDialog;



// WEBPACK FOOTER //
// ./src/components/OrderCommentDialog/OrderCommentDialog.js